<template>
  <div class="d-flex justify-content-center my-3 flex-column align-items-center">
    <div>
      <div class="spinner-border spinner-class"></div>
    </div>
    <div>Loading {{ name }}...</div>
  </div>
</template>

<script>
export default { name: "SimpleLoader", props: { name: { default: "", type: String } } }
</script>



// WEBPACK FOOTER //
// src/components/commons/SimpleLoader.vue